<template lang="pug">
include TrainerRegisterCategoriesPublic.pug
</template>

<script type="text/javascript">
import { isEmpty } from 'underscore'
import TrainerTitle from '@/components/trainer_title/TrainerTitle'

export default {
  name: "TrainerRegisterCategoriesPublic",
  props: ["trainer", "onlyCecs"],
  components: {TrainerTitle},
  data() {
    return {
      version: null
    }
  },
  computed: {
    hasLevel() {
      if (this.version === 1) {
        return !this.onlyCecs
      }

      if (this.version === 2) {
        let hasLevel = false
        for (const course of this.trainer.courses_v2) {
          if (!isEmpty(course.level)) hasLevel = true
        }
        return hasLevel
      }
    }
  },
  created() {
    // detect presentation model
    const coursesV2 = this.trainer.courses_v2
    const courses = this.trainer.courses
    const hasCoursesV2 = (coursesV2.length > 0)

    if (hasCoursesV2) {
      this.version = 2
    } else {
      this.version = 1
    }
  }
}
</script>

<style scoped lang="scss">
@import './../variables';
@import '../variables_colreps';
@import '../variables_mexreps';
@import './TrainerView';

.context-colreps {
  @import 'TrainerViewColreps';
}

.context-mexreps {
  @import 'TrainerViewMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/TrainerRegisterCategoriesPublic.vue